import styles from '../styles/modal.module.scss';

import { Button, Flex, Heading, View } from '@aws-amplify/ui-react';

const PlainModal = ({ isOpen, onClose, title, body, closeBtnColor }: PropTypes) => {
  return (
    <View className={styles.modal_main}>
      <View className={styles.modal_view}>
        <Flex justifyContent="space-between" alignItems="center">
          <Heading level={4}>{title}</Heading>
          <Button onClick={onClose}>&times;</Button>
        </Flex>
        <View style={{ marginTop: '15px' }}>
          <div dangerouslySetInnerHTML={{ __html: body }} />
        </View>
        <Flex justifyContent="flex-end" style={{ marginTop: '20px' }}>
          <Button onClick={onClose} variation="primary" style={{ backgroundColor: closeBtnColor }}>
            Close
          </Button>
        </Flex>
      </View>
    </View>
  );
};

interface PropTypes {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body: string;
  closeBtnColor: string;
}

export default PlainModal;
